/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n<div class="modal-header">\n  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>\n  <h2>\n    Select Display Image\n  </h2>\n</div>\n<div class="modal-body">\n  <div class="mainThumbnail">\n    <div class="current-image-label">\n      Current image\n    </div>\n    ';
 if (data.selectedImageSrc) { ;
__p += '\n      <img src="' +
__e( data.selectedImageSrc ) +
'"/>\n    ';
 } else { ;
__p += '\n      <div class="missing-thumbnail">\n        Missing thumbnail <br> <i class="fa fa-exclamation-circle"></i>\n      </div>\n    ';
 } ;
__p += '\n  </div>\n  <div class="thumbnail-options">\n    <div class="choose-option-label">\n      Select new image:\n    </div>\n    ';
 _.each(data.assetData.allThumbnails, function(thumbnailSrc){ ;
__p += '\n      ';
 if (thumbnailSrc !== data.assetData.thumbnail) { ;
__p += '\n        <div class="thumbnailChoice action-choose-thumbnail" data-thumbnail-src="' +
__e(thumbnailSrc) +
'">\n          <img src="' +
__e(thumbnailSrc) +
'"/>\n        </div>\n      ';
 } ;
__p += '\n    ';
 }); ;
__p += '\n  </div>\n</div>\n<div class="modal-footer">\n  <div class="cancel-button" data-dismiss="modal" aria-hidden="true">\n    Cancel\n  </div>\n</div>';
return __p
}
